<template>
  <v-card class="custom-card">
    <v-row>
      <v-col>
        <v-row>
          <!-- CHART -->
          <v-col cols="10" class="chart-col">
            <!-- Buttons -->
            <v-row class="chart-btns">
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 0 ? 'primary' : '#D8E0E6'"
                  :class="period == 0 ? '' : 'gray-button'"
                  @click="updateStats(0)"
                  >All</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 7 ? 'primary' : '#D8E0E6'"
                  :class="period == 7 ? '' : 'gray-button'"
                  @click="updateStats(7)"
                  >7D</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 15 ? 'primary' : '#D8E0E6'"
                  :class="period == 15 ? '' : 'gray-button'"
                  @click="updateStats(15)"
                  >15D</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 40 ? 'primary' : '#D8E0E6'"
                  :class="period == 40 ? '' : 'gray-button'"
                  @click="updateStats(40)"
                  >1M</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 90 ? 'primary' : '#D8E0E6'"
                  :class="period == 90 ? '' : 'gray-button'"
                  @click="updateStats(90)"
                  >3M</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 180 ? 'primary' : '#D8E0E6'"
                  :class="period == 180 ? '' : 'gray-button'"
                  @click="updateStats(180)"
                  >6M</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  :color="period == 365 ? 'primary' : '#D8E0E6'"
                  :class="period == 365 ? '' : 'gray-button'"
                  @click="updateStats(365)"
                  >1A</v-btn
                >
              </v-col>
            </v-row>
            <!-- Chart -->
            <v-row>
              <LineChart
                v-if="loaded"
                :dataLabels="labels"
                :userStats="stats"
                class="chart"
                :key="'chart-' + statsVersion"
              ></LineChart>
            </v-row>
          </v-col>
          <!-- STATS -->
          <v-col cols="2" class="stats-col" style="padding: 18px 24px">
            <v-row class="statistics-row">
              <v-col>
                <div class="gray-label">Registados</div>
                <div class="black-value">
                  {{ totalRegistered }}
                </div>
              </v-col>
              <v-col>
                <div class="gray-label">Free</div>
                <div class="black-value">
                  {{ totalRegistered - totalActive }}
                </div>
              </v-col>
              <v-col cols="12">
                <div class="gray-label">Payed User</div>
                <div class="black-value">
                  {{ totalActive }}
                </div>
              </v-col>
              <v-col> </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.statistics-row .col {
  padding: 4px 12px 0 12px;
}
.statistics-row .black-value {
  font-size: 36px;
  line-height: 48px;
}
.custom-card.v-card {
  padding: 0 24px !important;
}
.header-row .col:first-child {
  min-width: 150px;
  position: relative;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e;
  padding-right: 4px;
  vertical-align: top;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.black-value {
  font-family: Gilroy-Medium;
  font-size: 14px;
  line-height: 24px;
  color: #304351;
}
.positive::first-letter {
  color: #26ab5e;
}
.negative::first-letter {
  color: #f83030;
}
.big-black-value {
  overflow-wrap: initial;
  font-family: Gilroy-SemiBold;
  font-size: 24px;
  line-height: 28px;
  color: #304351;
}
.header-row .v-icon {
  float: left;
  margin-top: 3px;
  margin-right: 4px;
}
.chart-row {
  background: #f7f9fa;
  left: -12px;
  position: relative;
  width: calc(100% + 48px);
  border-top: 1px solid #d8e0e6;
  border-bottom: 1px solid #d8e0e6;
}
.chart-row .col {
  padding: 12px 24px;
}
.chart {
  height: 168px;
  position: relative;
  width: 100%;
  margin-left: 8px;
}
.buttons-row .col {
  padding-top: 20px;
}
.green-button >>> .v-btn__content {
  color: #26ab5e;
}
.small-btn {
  flex: 0 0 26%;
  max-width: 26%;
}
.dialog-text >>> .v-input__slot {
  background-color: #bee6cf !important;
  border-radius: 4px !important;
}
.dialog-text >>> .v-text-field__slot input,
.dialog-text >>> .v-input__slot {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #26ab5e;
  padding: 0 !important;
}
.dialog-text >>> .v-text-field__slot input::-webkit-outer-spin-button,
.dialog-text >>> .v-text-field__slot input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
.dialog-text >>> .v-text-field__slot input[type="number"] {
  -moz-appearance: textfield;
}
.dialog-text >>> .v-input__slot::before,
.dialog-text >>> .v-input__slot::after {
  display: none !important;
}
.dialog-text >>> .v-text-field__slot {
  padding-left: 16px;
}
.dialog-text >>> .v-input__prepend-inner {
  color: #ffffff;
  background: #26ab5e;
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
  padding: 17px 23px;
  margin: 0 !important;
}
.dialog-text >>> .v-input__append-inner {
  margin: 0 !important;
  padding: 17px;
  border-left: 1px solid #26ab5e;
}
@media only screen and (max-width: 767px) {
  .statistics-col {
    flex: 0 0 33%;
    max-width: 33%;
  }
  .stats-col,
  .chart-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .chart-btns .col {
    max-width: max-content;
  }
}
@media only screen and (max-width: 480px) {
  .small-btn {
    min-width: 50%;
  }
}
</style>

<script>
import Vue from "vue";
import LineChart from "@/components/LineChart.vue";

import ApiService from "@/services/api.service";
import DateTimeService from "@/services/datetime.service";

export default Vue.extend({
  name: "AppostaCard",
  components: {
    LineChart,
  },
  props: {
    userStats: {},
    isComponent: Boolean,
  },
  data: () => ({
    resetDialog: false,
    createDialog: false,
    bankAmount: 0,
    stats: {},
    labels: [],
    subscriptions: [],
    registrations: [],
    loaded: false,
    statsVersion: 0,
    period: 0,
    totalRegistered: 0,
    totalActive: 0,
  }),
  created() {
    this.parseStatsForChart(this.userStats, 0);
    this.calculateTotals(this.userStats);
  },
  methods: {
    getFirstDate(sub, reg) {
      if (sub.year < reg.year) {
        return sub;
      } else if (reg.year < sub.year) {
        return reg;
      } else {
        if (sub.month < reg.month) {
          return sub;
        } else if (reg.month < sub.month) {
          return reg;
        } else {
          if (sub.day < reg.day) {
            return sub;
          } else if (reg.day < sub.day) {
            return reg;
          } else {
            return sub;
          }
        }
      }
    },
    parseStatsForChart(userStats, period) {
      this.labels = [];
      this.subscriptions = [];
      this.registrations = [];
      this.loaded = false;
      let startDate = DateTimeService.getDateMinusDays(period);
      const endDate = DateTimeService.getNow();
      const subArray = userStats.subscriptionStats;
      const regArray = userStats.registrationStats;

      if (period == 0 || period > 40) {
        // Labels for a set of months
        let subIndex = 0;
        let regIndex = 0;

        if (period == 0) {
          const first = this.getFirstDate(subArray[0], regArray[0]);
          startDate = DateTimeService.getDateFromString(
            first.year,
            first.month,
            first.day
          );
        }

        while (startDate <= endDate) {
          this.labels.push(
            DateTimeService.getMonthString(startDate.month() + 1) +
              " '" +
              startDate.year().toString().substring(2)
          );

          if (
            subArray[subIndex] &&
            subArray[subIndex].month == startDate.month() + 1
          ) {
            this.subscriptions.push(subArray[subIndex].count);
            subIndex++;
          } else {
            this.subscriptions.push(0);
          }

          if (
            regArray[regIndex] &&
            regArray[regIndex].month == startDate.month() + 1
          ) {
            this.registrations.push(regArray[regIndex].count);
            regIndex++;
          } else {
            this.registrations.push(0);
          }

          startDate.add(1, "months");
        }
      } else {
        // labels for a set of days
        let subIndex = 0;
        let regIndex = 0;

        while (startDate <= endDate) {
          this.labels.push(
            startDate.date() + " " + DateTimeService.getMonthString(startDate)
          );

          if (
            subArray[subIndex] &&
            subArray[subIndex].day == startDate.date() &&
            subArray[subIndex].month == startDate.month()
          ) {
            this.subscriptions.push(subArray[subIndex].count);
            subIndex++;
          } else {
            this.subscriptions.push(0);
          }

          if (
            regArray[regIndex] &&
            regArray[regIndex].day == startDate.date() &&
            regArray[regIndex].month == startDate.month()
          ) {
            this.registrations.push(regArray[regIndex].count);
            regIndex++;
          } else {
            this.registrations.push(0);
          }

          startDate.add(1, "days");
        }
      }

      this.stats["subscriptions"] = this.subscriptions;
      this.stats["registrations"] = this.registrations;

      this.loaded = true;
      this.statsVersion += 1;
    },
    isBackoffice() {
      return this.$route.path.includes("backoffice");
    },
    isPremium() {
      return this.$store.state.premium;
    },
    getBalance() {
      return this.$store.state.balance ? this.$store.state.balance : 0;
    },
    updateStats(period) {
      this.period = period;
      ApiService.getGraphQLUserStatsCurrentTiroCerteiroWithPeriod(period).then(
        (response) => {
          const data = response.data.data;
          this.parseStatsForChart(data.getUserStats, period);
          this.calculateTotals(data.getUserStats);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    calculateTotals(userStats) {
      let totalSub = 0;
      userStats.subscriptionStats.map((stats) => {
        totalSub += stats.count;
      });
      this.totalActive = totalSub;

      let totalReg = 0;
      userStats.registrationStats.map((stats) => {
        totalReg += stats.count;
      });
      this.totalRegistered = totalReg;
    },
  },
});
</script>
